import React, { useContext } from 'react';
import styled from 'styled-components';
// import { PillGroup, SingleSelect } from '@ikea-ux/pill-button';
import '@ingka/pill/dist/style.css';
import "@ingka/focus/dist/style.css";
import Pill from "@ingka/pill";
import DataContext from '../DataContext/DataContext';
import './MenuCategoryList.css';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 16px;
`;

const MenuCategoryList = ({ selectedCategoryName, onChange = () => {}, sortedPpsis = [] }) => {
  const { config, language } = useContext(DataContext);
  const categories = config.kcFilteringOptions || [];

  const pillClicked=(nameIdentifier)=> {
    const clickedCategoryName = nameIdentifier;
    onChange(
      selectedCategoryName === clickedCategoryName ? null : nameIdentifier
    );
  }

  let availCodeList = [];
  let codeList = categories.map(a=>a.code).flat();
  sortedPpsis.forEach(a=> {
      if(codeList.includes(a.kcFilterCode)){
          availCodeList.push(a.kcFilterCode)
      };
  });

  availCodeList =  [...new Set(availCodeList)];

  return (
    <Container>
       {categories.filter(cat => cat.isActive).map(({ nameIdentifier, info, code, isActive }) => {
          if (nameIdentifier === 'all') {
            return null;
          }
          const codeList = code
          const { text } = info[language];
          const condition = !codeList.filter(a=>availCodeList.includes(a)).length
          return (
          <Pill className={condition ? "pillCustomCSS disablePill" : 'pillCustomCSS'}
          id={nameIdentifier}
          key={nameIdentifier}
          label={text}
          onClick={e=>pillClicked(nameIdentifier)}
          selected={nameIdentifier === selectedCategoryName}
          // disabled={!codeList.filter(a=>availCodeList.includes(a)).length}
         />
          )
        })}
      

      {/* <PillGroup onClick={pillClicked}>
        {categories.map(({ nameIdentifier, info }) => {
          if (nameIdentifier === 'all') {
            return null;
          }
          const { text } = info[language];
          return (
            <SingleSelect
              group="category"
              id={nameIdentifier}
              checked={nameIdentifier === selectedCategoryName}
              text={text}
              key={nameIdentifier}
            />
          );
        })}
      </PillGroup> */}
    </Container>
  );
};

export default MenuCategoryList;
